import { Timestamp, Query, query, where, orderBy } from 'firebase/firestore';

import { getItems, deleteItemsByIds, saveItem } from './genericFB';
import { IExposureHistory } from '../utils/exposureUtils';

export const EXPOSURE_HISTORY = 'exposure-history';

export const saveExposureHistory = async (exposure: IExposureHistory): Promise<IExposureHistory | null> => {
  return saveItem<IExposureHistory>(exposure.key, exposure, EXPOSURE_HISTORY);
};

export const getExposureHistory = async (
  accountId: string,
  fromDate: Date,
): Promise<IExposureHistory[] | undefined> => {
  return getItems<IExposureHistory>(accountId, EXPOSURE_HISTORY, (q: Query) =>
    query(
      q,
      where('accountId', '==', accountId),
      where('createDate', '>=', Timestamp.fromDate(fromDate)),
      orderBy('createDate', 'asc'),
    ),
  );
};

export const getExposureHistoryByAccountAndMaterial = async (
  accountId: string,
  materialId: string,
  fromDate: Date,
): Promise<IExposureHistory[] | undefined> => {
  return getItems<IExposureHistory>(accountId, EXPOSURE_HISTORY, (q: Query) =>
    query(
      q,
      where('accountId', '==', accountId),
      where('materialId', '==', materialId),
      where('createDate', '>=', Timestamp.fromDate(fromDate)),
      orderBy('createDate', 'asc'),
    ),
  );
};

export const deleteExpHistoryForAccount = async (accountId: string): Promise<void> => {
  const expHistories = await getItems<IExposureHistory>(accountId, EXPOSURE_HISTORY);
  const eres = await deleteItemsByIds(expHistories?.map((eh) => eh.key) || [], EXPOSURE_HISTORY);
  console.log('Deleted exposure histories:', eres);
};
